import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dynamicElementsDiscountLabel } from '@epicuro-next/constants/dynamic-elements';
import { productIconsLabels } from '@epicuro-next/constants/features/localization';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { FloatRange } from 'graphql-api/gql-api-interfaces';
@DynamicComponentRegister(dynamicElementsDiscountLabel)
@Component({
  selector: 'atx-discount-label',
  templateUrl: './discount-label.component.html',
  styleUrls: ['./discount-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DiscountLabelComponent {
  @Input() public discount: FloatRange;

  public get discountLabel() {
    if (this.discount?.max === this.discount?.min) {
      return $localize`:Pulse|product discount value label@@productDiscountSingleLabel:-${this.discount?.max}%`;
    }
    return productIconsLabels.discount([this.discount.max ?? '']);
  }
}
